import { Chart, ChartDataSeries } from '@frontend/chart/types';

export type ChartSeriesRankDirection = 'highest' | 'lowest';

const seriesTotal = (series: ChartDataSeries): number => (series.data ?? []).reduce((sum, point) => sum + point.value, 0);

const sortBySeriesTotal = (series: ChartDataSeries[], direction: ChartSeriesRankDirection): ChartDataSeries[] =>
    [...series].sort((left, right) => {
        const diff = seriesTotal(right) - seriesTotal(left);
        return direction === 'highest' ? diff : -diff;
    });

export const takeRankedChartSeries = (chart: Chart, direction: ChartSeriesRankDirection, limit: number): Chart => ({
    series: sortBySeriesTotal(chart.series ?? [], direction).slice(0, limit)
});

/**
 * Splits series into highest and lowest groups with no overlap.
 * Each side gets `min(maxLimit, floor(n / 2))` items so products never appear in both lists.
 */
export const splitRankedChartSeries = (chart: Chart, maxLimit = 5): { highest: Chart; lowest: Chart } => {
    const series = chart.series ?? [];
    const limit = Math.min(maxLimit, Math.floor(series.length / 2));

    return {
        highest: { series: sortBySeriesTotal(series, 'highest').slice(0, limit) },
        lowest: { series: sortBySeriesTotal(series, 'lowest').slice(0, limit) }
    };
};
